export default "__VITE_ASSET__DnMtgrPJ__"